// fixme: replace field types with semantic types (need API change)

export class LoginInfo {
  userId: string;                   // number?
  company: string;                  // companyName: string?
  firstName: string;
  lastName: string;
  role: string;                     // roleName: string?
  roleClassID: string;              // roleId: number?
  avatarURL: string;
  token: string;                    // needed?
  partnerId: string;                // number?
  profileId: string;                // number?
  clientId: string;                 // number?
  fileUrl: string;                  // which file? needed?
  classYearDescription: string;     // what is responsibility of this field?
  moduleName: string;
  module: string;                   // duplicated field. needed?
  isLogin: string;                  // boolean?
  isFirstLogOn: string;             // boolean?
  route: any;                       // string?
  email: string;
  stateClassID: string;             // stateId: number?
}
